/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  ButtonGroup,
  SvgIcon,
  Select
} from '../'

import {
  default as PageRange
} from './PageRange'

import {
  decodeBase64
} from '../../utils'

const getCurrentPageNumberFromCursor = (cursor, resultsPerPage) => {
  let cursorNumber = decodeBase64(cursor).split(':').pop()

  if (cursorNumber > 0) {
    return Math.trunc(cursorNumber / resultsPerPage) + 1
  } else {
    return 1
  }
}

export const PageNavigationButtons = ({ previousLabel, nextLabel, onPreviousClick, onNextClick,
  previousDisabled, nextDisabled, gap, minWidth, inverseButtons, startCursor, totalCount, totalAmountIncl,
  resultsPerPage, resultsText, maxPageLinks, onPageNumberClick, onResultsPerPageChange, className }) => {

  let lastPage = totalCount
    ? Math.ceil(totalCount / resultsPerPage)
    : null

  let currentPage = startCursor
    ? getCurrentPageNumberFromCursor(startCursor, resultsPerPage)
    : null

  return (
    <div className={`slds-grid ${className}`} style={{ justifyContent: 'space-between' }}>
      {onResultsPerPageChange &&
        <div className='slds-grid slds-p-top_small slds-m-right_medium'>
          <div className='slds-p-top_xxx-small'>
            Show:
          </div>
          <Select
            value={resultsPerPage}
            options={[10, 15, 25, 40, 50]}
            onChange={onResultsPerPageChange}
            className='slds-m-left_x-small slds-m-right_x-small'
            minWidth={60}
          />
          <div className='slds-p-top_xxx-small'>
            results per page
          </div>
        </div>
      }
      <ButtonGroup className='slds-col_bump-left'>
        <Button
          type={inverseButtons ? 'inverse' : null}
          onClick={onPreviousClick}
          disabled={totalCount
            ? currentPage === 1
            : previousDisabled
          }
          minWidth={minWidth}
          className={gap ? `slds-m-right_${gap}` : ''}>
          <SvgIcon
            variant="utility"
            symbol="chevronleft"
            colour="inherit"
            buttonIcon={true}
          />
          {previousLabel ? ` ${previousLabel}` : ''}
        </Button>
        {totalCount &&
          <PageRange
            currentPage={currentPage}
            totalCount={totalCount}
            totalAmountIncl={totalAmountIncl}
            numberOfPages={lastPage}
            resultsPerPage={resultsPerPage}
            resultsText={resultsText}
            onClick={onPageNumberClick}
          />
        }
        <Button
          type={inverseButtons ? 'inverse' : null}
          onClick={onNextClick}
          disabled={lastPage
            ? currentPage === lastPage
            : nextDisabled
          }
          minWidth={minWidth}>
          {nextLabel ? `${nextLabel} ` : ''}
          <SvgIcon
            variant="utility"
            symbol="chevronright"
            colour="inherit"
            buttonIcon={true}
          />
        </Button>
      </ButtonGroup>
    </div>
  )
}

PageNavigationButtons.propTypes = {
  previousLabel: PropTypes.string,
  nextLabel: PropTypes.string,
  onPreviousClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  previousDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  gap: PropTypes.oneOf([
    "xx-small", "x-small", "small",
    "medium",
    "large", "x-large", "xx-large"
  ]),
  minWidth: PropTypes.number,
  inverseButtons: PropTypes.bool,
  totalCount: PropTypes.number,
  totalAmountIncl: PropTypes.number,
  resultsPerPage: PropTypes.number,
  resultsText: PropTypes.string,
  maxPageLinks: PropTypes.number,
  onPageNumberClick: PropTypes.func,
  onResultsPerPageChange: PropTypes.func,
  className: PropTypes.string
}

PageNavigationButtons.defaultProps = {
  className: '',
  previousLabel: '',
  nextLabel: ''
}



// WEBPACK FOOTER //
// ./src/components/page-navigation-buttons/index.js